import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import { withPrefix } from 'gatsby-link'

import './base.scss'
import './scopes.header.scss'
import './scopes.sidebar.scss'
import './scopes.main.scss'
import logo from '../img/logo.svg'
import { classNames } from '../utilities'
import { lang } from '../language'

if (typeof window !== `undefined`) { require('particles.js') }

class Header extends React.Component {
  render() {
    const version = this.props.version

    return (
      <header className="s-header">
        <Link to="/">
          <img className="logo" src={ logo }/>
        </Link>

        <h1 className="theme-name">Ocelli Ocellus - { version.version }</h1>

        <span className="hamburger" onClick={ this.toggleNav }><i className="material-icons">menu</i></span>
      </header>
    )
  }

  toggleNav() {
    document.querySelector('.s-sidebar').classList.toggle('state-active')
  }
}

class Navigation extends React.Component {
  render() {
    const navItems = this.props.navItems
    const homepage = this.props.homepage
    const pathname = typeof window !== `undefined` ? window.location.pathname : false

    return (
      <nav className="s-sidebar">
        <div className="particles-background" id="js-particles-background"></div>

        <ul className="navigation">
          <li><Link className={ classNames('navigation-link', {'state-active': __PATH_PREFIX__ + '/' == pathname}) } to="/">{ homepage['heading' + lang] }</Link></li>

          {navItems.map(({ node }, index) =>
            <li key={ index }>
              <Link className={ classNames('navigation-link', {'state-active': __PATH_PREFIX__ + '/' + node.url == pathname}) } to={ '/' + node.url }>{ node['title' + lang] }</Link>
            </li>
          )}
        </ul>
      </nav>
    )
  }

  componentDidMount() {
    particlesJS.load('js-particles-background', __PATH_PREFIX__ + '/particles.config.json')
  }
}

const TemplateWrapper = ({ children, data }) => {
  return (
    <div>
      <Helmet>
        <title>Guide: Theme Ocelli Ocellus</title>
        <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700,900"/>
        <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons"/>
        <meta name="robots" content="noindex"/>
      </Helmet>

      <Header version={ data.allTranslationsXlsxChangelog.edges[0].node }/>
      <main className="s-main">
        <Navigation
          homepage={ data.allTranslationsXlsxHomepage.edges[0].node }
          navItems={ data.allTranslationsXlsxSections.edges }
        />
        <section className="content">{ children() }</section>
      </main>
    </div>
  )
}

export default TemplateWrapper

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export const query = graphql`
  query NavigationQuery {
    allTranslationsXlsxSections {
      edges {
        node {
          url
          title
          title_nl
          title_de
        }
      }
    }
    allTranslationsXlsxHomepage(filter: { key: { eq: "introduction" } }) {
      edges {
        node {
          heading
          heading_nl
          heading_de
        }
      }
    }
    allTranslationsXlsxChangelog {
      edges {
        node { version }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js